import { Flex, Heading, IconCheckmarkCircle, IconLightning, Paragraph, Tag, Text } from '@zillow/constellation';
import { TourConfirmationType } from '@zg-rentals/ts-z-calendar-client';

import { TOUR_CONFIRMATION_TYPE_LAYOUT, type TOUR_OPTION } from '../../constants/TourCalendar';

type TourIconProps = {
  confirmationType: TourConfirmationType;
  isHorizontal: boolean;
};

const TourIcon = ({ confirmationType, isHorizontal }: TourIconProps) => {
  const size = isHorizontal ? 'sm' : 'md';

  if (confirmationType === TourConfirmationType.INSTANT) {
    return <IconLightning size={size} />;
  }

  return <IconCheckmarkCircle size={size} />;
};

type TourConfirmationTypeCardProps = {
  layout: TOUR_CONFIRMATION_TYPE_LAYOUT;
  titleTag?: keyof JSX.IntrinsicElements;
  tourConfirmationType?: TourConfirmationType;
  tourOption: TOUR_OPTION;
  tourTitleTag?: keyof JSX.IntrinsicElements;
};

const TourConfirmationTypeCard = ({
  layout,
  titleTag,
  tourConfirmationType,
  tourOption,
  tourTitleTag,
}: TourConfirmationTypeCardProps) => {
  if (layout === TOUR_CONFIRMATION_TYPE_LAYOUT.HORIZONTAL) {
    return (
      <Flex display="flex" flexDirection="row" gap="sm">
        <Text fontColor={tourOption.id === tourConfirmationType ? 'brand' : 'textMedium'}>
          <TourIcon confirmationType={tourOption.id} isHorizontal />
        </Text>

        <Flex display="flex" flexDirection="column" gap="xs">
          <Flex display="flex" flexDirection="row" justifyContent="space-between">
            <Heading level={6} as={tourTitleTag ?? 'h6'}>
              {tourOption.title}
            </Heading>
            <Tag size="sm">{tourOption.subTitle}</Tag>
          </Flex>
          <Paragraph fontColor="textMedium" fontType="bodySmall">
            {tourOption.description}
          </Paragraph>
        </Flex>
      </Flex>
    );
  }

  return (
    <Flex display="flex" flexDirection="column" alignItems="center" gap="md" marginTop="xs" marginBottom="lg">
      <Text fontColor={tourOption.id === tourConfirmationType ? 'brand' : 'textMedium'}>
        <TourIcon confirmationType={tourOption.id} isHorizontal={false} />
      </Text>

      <Flex display="flex" flexDirection="column" alignItems="center" gap="sm">
        <Heading level={5} as={titleTag ?? 'h5'}>
          {tourOption.title}
        </Heading>
        <Tag>{tourOption.subTitle}</Tag>
      </Flex>
      <Paragraph fontColor="textMedium" fontType="bodySmall" marginX="xs" style={{ textAlign: 'center' }}>
        {tourOption.description}
      </Paragraph>
    </Flex>
  );
};

export default TourConfirmationTypeCard;
